<template>
  <div>
    <currentpage :page="'FREQUENTLY ASKED QUESTIONS'" :thispage="'Questions Asked'"></currentpage>
    <section id="faq">
      <b-container class="py-5 my-5">
        <h3 class="text-center">GENERAL QUESTIONS</h3>
        <p class="my-4">
          These are a curated list of questions that are asked by our valuable clients. We are here to meet your needs.
          Kindly go through them for your concerns to be addressed.
        </p>
        <b-row>
          <b-col>
            <div role="tablist">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="h3" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle.accordion1 class="py-3">
                    LOCATION
                    <span class="float-right opened">
                      <font-awesome-icon :icon="['far', 'minus-square']"/>
                    </span>
                    <span class="float-right closed">
                      <font-awesome-icon :icon="['far', 'plus-square']"/>
                    </span>
                  </b-btn>
                </b-card-header>
                <b-collapse id="accordion1" visible accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="font-weight-bold card-text">Where is Akai House Clinic located?</p>
                    <p class="card-text">
                      We are located in Cantonments, opposite Lord of the Wings, near the US Embassy.
                      No. 1, Sixth Circular Road, Cantonments Accra.
                    </p>
                    <b-button to="/contact#map">View on Map</b-button>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="h3" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle.accordion2 class="py-3">
                    CONTACT HOURS
                    <span class="float-right opened">
                      <font-awesome-icon :icon="['far', 'minus-square']"/>
                    </span>
                    <span class="float-right closed">
                      <font-awesome-icon :icon="['far', 'plus-square']"/>
                    </span>
                  </b-btn>
                </b-card-header>
                <b-collapse id="accordion2" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text font-weight-bold">When is Akai House Clinic open?</p>
                    <p class="card-text">
                      We are open from
                      <strong>8 a.m. to 5 p.m. Monday-Friday</strong> &amp;
                      <strong>8 a.m. to 2 p.m. on Saturday.</strong>
                    </p>
                    <p class="card-text font-weight-bold">Is Akai House Clinic open on holidays?</p>
                    <p class="card-text">
                      We are open from
                      <strong>8 a.m. to 2 p.m.</strong> on select holidays. You may
                      <a href="tel:0302784772">call</a> to confirm our hours.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="h3" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle.accordion3 class="py-3">
                    APPOINTMENTS
                    <span class="float-right opened">
                      <font-awesome-icon :icon="['far', 'minus-square']"/>
                    </span>
                    <span class="float-right closed">
                      <font-awesome-icon :icon="['far', 'plus-square']"/>
                    </span>
                  </b-btn>
                </b-card-header>
                <b-collapse id="accordion3" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text font-weight-bold">How do I make an appointment?</p>
                    <p class="card-text">
                      Call us on
                      <a href="tel:0302784772">(0) 302 784772</a> /
                      <a href="tel:0302784773">(0) 302 784773</a> /
                      <a href="tel:0302784774">(0) 302 784774</a> to confirm your appointment date and time.
                    </p>
                    <p class="card-text font-weight-bold">Can I walk-in?</p>
                    <p class="card-text">
                      Yes, You can walk-in. However, walk-ins will be attended to on a
                      <em>‘first come, first served’</em>
                      basis, so an appointment is the best option.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="h3" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle.accordion4 class="py-3">
                    SERVICES
                    <span class="float-right opened">
                      <font-awesome-icon :icon="['far', 'minus-square']"/>
                    </span>
                    <span class="float-right closed">
                      <font-awesome-icon :icon="['far', 'plus-square']"/>
                    </span>
                  </b-btn>
                </b-card-header>
                <b-collapse id="accordion4" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p
                      class="card-text font-weight-bold"
                    >What services and tests does Akai House Clinic offer?</p>
                    <p class="card-text">Please see the
                      <b-link to="/#services">Services</b-link> page for our full range of specialists and tests.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="h3" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle.accordion5 class="py-3">
                    PAYMENTS
                    <span class="float-right opened">
                      <font-awesome-icon :icon="['far', 'minus-square']"/>
                    </span>
                    <span class="float-right closed">
                      <font-awesome-icon :icon="['far', 'plus-square']"/>
                    </span>
                  </b-btn>
                </b-card-header>
                <b-collapse id="accordion5" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text font-weight-bold">How much will my visit cost?</p>
                    <p class="card-text">
                      Your bill will depend on any consultations and tests needed during your visit.
                      <a
                        href="tel:0302784772"
                      >Call</a> our Info Desk for information on fees.
                    </p>
                    <p class="card-text font-weight-bold">How can I pay for my visit?</p>
                    <p class="card-text">
                      We accept payment via
                      <strong>cash</strong>,
                      <strong>cheque &amp; card</strong>,
                      as well as
                      <strong>corporate &amp; insurance billing.</strong>
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="h3" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle.accordion6 class="py-3">
                    IMMIGRATION MEDICALS
                    <span class="float-right opened">
                      <font-awesome-icon :icon="['far', 'minus-square']"/>
                    </span>
                    <span class="float-right closed">
                      <font-awesome-icon :icon="['far', 'plus-square']"/>
                    </span>
                  </b-btn>
                </b-card-header>
                <b-collapse id="accordion6" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p
                      class="card-text font-weight-bold"
                    >What countries does Akai House Clinic Visa Section cater to?</p>
                    <p class="card-text">We carry out medicals for:
                      <b-nav vertical>
                        <b-nav-item>Australia</b-nav-item>
                        <b-nav-item>Belgium</b-nav-item>
                        <b-nav-item>Canada</b-nav-item>
                        <b-nav-item>New Zealand</b-nav-item>
                        <b-nav-item>The United States</b-nav-item>
                      </b-nav>
                    </p>
                    <p class="card-text font-weight-bold">When is the Visa Section open?</p>
                    <p class="card-text">
                      The Visa Section is open from
                      <em>Monday to Friday 8 a.m. - 3 p.m.</em> It is
                      <strong>NOT</strong> open for medicals on
                      <em>Saturday.</em>
                    </p>

                    <p class="card-text font-weight-bold">What do I need for my medicals?</p>
                    <p class="card-text">Please see the
                      <b-link to="/immigration-medicals">Visa Medicals page</b-link> for more information on what to bring to your medical check.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="h3" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle.accordion8 class="py-3">
                    INSURANCE
                    <span class="float-right opened">
                      <font-awesome-icon :icon="['far', 'minus-square']"/>
                    </span>
                    <span class="float-right closed">
                      <font-awesome-icon :icon="['far', 'plus-square']"/>
                    </span>
                  </b-btn>
                </b-card-header>
                <b-collapse id="accordion8" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p
                      class="card-text font-weight-bold"
                    >What insurance does Akai House Clinic accept?</p>

                    <table class="table table-bordered table-hoverable table-responsive-sm table-responsive-md">
                      <thead class="thead-dark">
                        <tr>
                          <th scope="col" colspan="2">INSURANCE</th>
                          <th scope="col">OPTIONS &amp; FEATURES</th>
                          <th scope="col">RESTRICTIONS</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td rowspan="6">LOCAL</td>
                          <td>ACACIA</td>
                          <td>SUPER CARE PLUS ONLY</td>
                          <td>NO SPECIALIST CONSULT EXCEPT BANK OF AFRICA STAFF &amp; GENERAL EXCLUSIONS</td>
                        </tr>
                        <tr>
                          <td rowspan="4">GLICO</td>
                          <td>PLATINUM</td>
                          <td>GENERAL EXCLUSIONS</td>
                        </tr>
                        <tr>
                          <td>ULTIMATE</td>
                          <td>GENERAL EXCLUSIONS</td>
                        </tr>
                        <tr>
                          <td>ULTIMATE PLUS</td>
                          <td>GENERAL EXCLUSIONS</td>
                        </tr>
                        <tr>
                          <td>E PLUS –SMT
                            <br>CUS. ULTIMATE
                          </td>
                          <td>GENERAL EXCLUSIONS</td>
                        </tr>
                        <tr>
                          <td>PREMIER MUTUAL HEALTH</td>
                          <td>PLATINUM PLUS</td>
                          <td>GENERAL EXCLUSIONS</td>
                        </tr>
                        <tr>
                          <td rowspan="7">FOREIGN</td>
                          <td rowspan="2">BUPA</td>
                          <td>MSO LOGO ON CARD</td>
                          <td>GENERAL EXCLUSIONS</td>
                        </tr>
                        <tr>
                          <td>GUARANTEE OF PAYMENT FROM MSO</td>
                          <td>GENERAL EXCLUSIONS</td>
                        </tr>
                        <tr>
                          <td rowspan="2">AETNA</td>
                          <td>MSO LOGO ON CARD</td>
                          <td>GENERAL EXCLUSIONS</td>
                        </tr>
                        <tr>
                          <td>GUARANTEE OF PAYMENT FROM MSO</td>
                          <td>GENERAL EXCLUSIONS</td>
                        </tr>
                        <tr>
                          <td>HTH</td>
                          <td>GUARANTEE OF PAYMENT LETTER</td>
                          <td>GENERAL EXCLUSIONS</td>
                        </tr>
                        <tr>
                          <td>INTERNATIONAL SOS</td>
                          <td>GUARANTEE OF PAYMENT LETTER</td>
                          <td>GENERAL EXCLUSIONS</td>
                        </tr>
                        <tr>
                          <td>VYV IA</td>
                          <td>GUARANTEE OF PAYMENT LETTER</td>
                          <td>GENERAL EXCLUSIONS</td>
                        </tr>
                      </tbody>
                    </table>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-1">
                <b-card-header header-tag="h3" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle.accordion7 class="py-3">
                    VACCINATIONS
                    <span class="float-right opened">
                      <font-awesome-icon :icon="['far', 'minus-square']"/>
                    </span>
                    <span class="float-right closed">
                      <font-awesome-icon :icon="['far', 'plus-square']"/>
                    </span>
                  </b-btn>
                </b-card-header>
                <b-collapse id="accordion7" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <p
                      class="card-text font-weight-bold"
                    >What vaccinations does Akai House Clinic offer?</p>
                    <p class="card-text">Please see the
                      <b-link to="/vaccination">Vaccinations page</b-link> for our full range of vaccinations.
                    </p>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
    }
  }
}
</script>

<style scoped>
.collapsed > .opened,
:not(.collapsed) > .closed {
  display: none;
}
/* #faq {
  background-image: url('/img/question.png') no-repeat 50% 50%;
} */
</style>
